import React, { useState } from 'react'
import { Button, CardContent, Typography, useMediaQuery } from '@mui/material'
import ModalContainer from '../../../../Components/AtomicDesign/atoms/ModalContainer/ModalContainer'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import RequestAAdvantageModal from '../../../Components/Modals/RequestAAdvantageModal'
import { startNewApplication } from '../CreditCardComparison/store'
import { APPLICATION_STEP } from '../../../options'
import { getApplicationStep } from '../../../context/global-application'
import { Spinner } from '../../../../Components/BackDrop'

const STEP_A_ADVANTAGE = {
  cardDetails: 'cardDetails',
  hasAAdvantage: 'hasAAdvantage',
  aAdvantageNumber: 'aAdvantageNumber',
  skipAAdvantage: 'skipAAdvantage'
}

const ModalCreditCard = ({ isOpen, onClose, modalInfo, setOpenModal }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [pending, setPending] = useState(false)

  // Responsive breakpoints
  const isMobile = useMediaQuery('(max-width:600px)')
  const isTablet = useMediaQuery('(max-width:960px)')

  // const [isSelectedCard, setIsSelectedCard] = useState(false)
  const [step, setStep] = React.useState(STEP_A_ADVANTAGE.cardDetails)

  const handleSelectedCard = (card) => {
    if (modalInfo.requiredAA) return setStep(STEP_A_ADVANTAGE.hasAAdvantage)
    handleStartApplication(card)
  }

  const handleStartApplication = (card = null) => {
    const sendData = {
      selectedCardId: card.id,
      aadvantageNumber: card.aAdvantage
    }

    if (!card.aAdvantage) delete sendData.aadvantageNumber

    setPending(true)
    dispatch(startNewApplication(sendData)).then((response) => {
      setPending(false)
      if (response?.payload.error?.message) {
        setError(true)
        return setErrorMessage(response?.payload.error?.message)
      }
      setError(false)
      setErrorMessage('')
      dispatch(getApplicationStep()).then((r) => {
        if (r?.payload?.olaApplication)
          return navigate(APPLICATION_STEP['credit-limit-request-cc'].path)
        navigate(APPLICATION_STEP['personal-information-review'].path)
      })
    })
    // console.log('sendData', sendData)
  }

  return (
    <React.Fragment>
      <Spinner hasError={error} open={pending} errorMessage={errorMessage}>
        <Button
          fullWidth
          style={{
            color: '#fff',
            background: '#0066A4',
            borderRadius: '1.5rem',
            marginTop: '2rem'
          }}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Spinner>
      <ModalContainer
        open={isOpen}
        onClose={onClose}
        width={isMobile ? '95%' : '100%'}
      >
        {[step].includes(STEP_A_ADVANTAGE.cardDetails) && (
          <div
            style={{
              padding: isMobile ? '1rem' : isTablet ? '2rem' : '3rem',
              overflowY: 'auto',
              height: 'auto',
              maxHeight: '80vh'
            }}
          >
            {modalInfo.segment && (
              <CardContent
                style={{
                  display: 'flex',
                  flexDirection: isTablet ? 'column' : 'row',
                  justifyContent: 'space-between',
                  alignItems: isTablet ? 'center' : 'start',
                  gap: isMobile ? '2rem' : '5rem',
                  flexWrap: 'wrap'
                }}
              >
                <div
                  style={{
                    minWidth: isMobile ? '100%' : isTablet ? '80%' : '400px',
                    maxWidth: isMobile ? '100%' : '539px'
                  }}
                >
                  <Typography
                    fontSize={isMobile ? 20 : 24}
                    fontWeight={700}
                    color='#091242'
                  >
                    {modalInfo.title}
                  </Typography>

                  {isMobile && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        margin: '1rem 0'
                      }}
                    >
                      <img
                        style={{
                          width: '100%',
                          maxWidth: '280px',
                          height: 'auto',
                          maxHeight: '180px',
                          objectFit: 'contain'
                        }}
                        src={modalInfo.cardImage}
                        alt=''
                      />
                    </div>
                  )}

                  <ul>
                    {modalInfo.bulletPoints.map((points) => (
                      <li key={points.id}>
                        <Typography fontSize={isMobile ? 12 : 14}>
                          {points.text}
                        </Typography>
                      </li>
                    ))}
                  </ul>
                  <hr />
                  {modalInfo.benefits.map((benefit) => (
                    <div
                      key={benefit.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.7rem',
                        marginBottom: '1rem'
                      }}
                    >
                      <img
                        src={benefit.icon}
                        alt=''
                        style={{ maxWidth: '100%' }}
                      />
                      <Typography color='#868686' fontSize={isMobile ? 12 : 14}>
                        <div
                          dangerouslySetInnerHTML={{ __html: benefit.text }}
                        />
                      </Typography>
                    </div>
                  ))}
                </div>

                {/* Card image and button for non-mobile views */}
                {!isMobile && (
                  <div
                    style={{
                      marginTop: isTablet ? '1rem' : '2rem',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      width: isMobile ? '100%' : 'auto'
                    }}
                  >
                    <img
                      style={{
                        width: '100%',
                        maxWidth: '359px',
                        height: 'auto',
                        maxHeight: '228px',
                        objectFit: 'contain'
                      }}
                      src={modalInfo.cardImage}
                      alt=''
                    />
                    <div
                      style={{
                        marginTop: '2rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '3rem',
                        width: '100%'
                      }}
                    >
                      <Button
                        style={{
                          backgroundColor: '#005FAA',
                          borderRadius: '2rem',
                          padding: '0.5rem 2rem',
                          fontSize: '1rem'
                        }}
                        variant='contained'
                        fullWidth
                        onClick={() => handleSelectedCard(modalInfo)}
                      >
                        Select This Card.
                      </Button>
                    </div>
                  </div>
                )}

                {/* Button for mobile view - positioned at the bottom */}
                {isMobile && (
                  <div
                    style={{
                      marginTop: '1rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '1rem',
                      width: '100%'
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: '#005FAA',
                        borderRadius: '2rem',
                        padding: '0.5rem 1rem',
                        fontSize: '0.8rem'
                      }}
                      variant='contained'
                      fullWidth
                      onClick={() => handleSelectedCard(modalInfo)}
                    >
                      Select This Card.
                    </Button>
                  </div>
                )}
              </CardContent>
            )}
          </div>
        )}

        <RequestAAdvantageModal
          openModal={[step].includes(STEP_A_ADVANTAGE.hasAAdvantage)}
          setOpenModal={(isOpen) => {
            setStep(isOpen)
            setStep(STEP_A_ADVANTAGE.cardDetails)
          }}
          startApplication={(aAdvantageValue) =>
            handleStartApplication({
              ...modalInfo,
              aAdvantage: aAdvantageValue
            })
          }
        />
      </ModalContainer>
    </React.Fragment>
  )
}

export default ModalCreditCard
